import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Comment, CommentCreate} from '../../shared/models/comment.model';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-form-calendar-comment',
    templateUrl: './form-calendar-comment.component.html',
    styleUrls: ['./form-calendar-comment.component.css']
})
export class FormCalendarCommentComponent implements OnInit, OnDestroy {
    @Input() month: string;
    @Input() date: string;
    @Input() user_id: number;
    commentForm: FormGroup;
    monthcomment: boolean = false;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private dataStorageService: DataStorageService) {
    }

    ngOnInit() {
        if (this.month) {
            this.monthcomment = true;
        }
        this.initForm();
    }

    initForm() {
        this.commentForm = new FormGroup({
            'comment': new FormControl()
        });
    }

    onSubmit() {
        const commentCreate = new CommentCreate(this.commentForm.get('comment').value, this.user_id);

        if (this.monthcomment) {
            commentCreate.month = this.month;
            this.dataStorageService.createCommentMonth(commentCreate)
                .pipe(takeUntil(this.unsubscribe$)).subscribe(
                responseData => {
                    if (responseData['error']) {
                        console.log('saving comment error');
                    } else {
                        alert('Month_comment added. ');
                        location.reload();
                    }
                });

        }

        if (this.date && !this.monthcomment) {
            commentCreate.date = this.date;
            this.dataStorageService.createCommentDate(commentCreate)
                .pipe(takeUntil(this.unsubscribe$)).subscribe(
                responseData => {
                    if (responseData['error']) {
                        console.log('saving comment error');
                    } else {
                        alert('Date_comment added. ');
                        location.reload();
                    }
                });
        }
    }


    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
